export default "__VITE_ASSET__wlholM9i__"